import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "15",
      height: "15",
      x: "1.5",
      y: "1.5",
      stroke: "currentColor",
      "stroke-width": "3",
      rx: "7.5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9",
      cy: "9",
      r: "6",
      fill: "#43CF58"
    }, null, -1)
  ])))
}
export default { render: render }